module.exports = __webpack_public_path__ + "img/IMG_1992.53f20714.jpg";